import { ColumnChart } from '..'

const CATEGORIES = [
  '60 - 65%',
  '65 - 70%',
  '70 - 75%',
  '75 - 80%',
  '80 - 85%',
  '85 - 90%',
  '90 - 95%',
  '95 - 100%'
]

const TOOLTIP_FORMATTER = that => {
  const { category, y: trades } = that.point as any

  return `<div class="column-chart-tooltip-wrapper"><h2>${category}</h2><p>Trades: ${trades}</p></div>`
}

interface Props {
  protectionLevels: { x: number; y: number }[]
}
export const ProtectionLevelColumnChart = ({ protectionLevels }: Props) => (
  <ColumnChart
    categories={CATEGORIES}
    data={protectionLevels}
    tooltipFormatter={TOOLTIP_FORMATTER}
  />
)
